<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" :atras="atras" />

        <h5 class="regisTituloUsuario">Informe de Solicitudes</h5>

        <br />

        <iframe
            src="/metabase/public/dashboard/15120a18-57de-46cb-b857-cd9506b902d6"
            frameborder="0"
            width="100%"
            height="600px"
            allowtransparency>
        </iframe>
    </div>
</template>

<script>
import HeaderGeneral from "../../components/HeaderGeneral.vue";

export default {
    name: "InformeSolicitudes",
    components: {
        HeaderGeneral
    },
    data() {
        return {
            vista: "Informe Solicitudes",
            carpeta: "Prestadores",
            proveniente: " - Informe Solicitudes",
            atras: false
        };
    }
};
</script>

<style scoped>
.regisTituloUsuario {
    font-size: 20px !important;
    text-align: left !important;
    font-weight: 100 !important;
    color: var(--blue-violet);
}
</style>
